
import { AutogenLayoutUnassignPrompt } from "./autogen/AutogenLayoutUnassignPrompt";

export class UnassignPrompt extends AutogenLayoutUnassignPrompt {

}


